module.exports = __webpack_public_path__ + "yz/img/wave.1d147030.png";